import {WCBaseComponent} from './WCBaseComponent.js';

const template = document.createElement('template');

template.innerHTML = `
  <nav class="wc-list-pagination py-2">
    <ul class="wc-list-pagination-ul pagination pagination-sm m-0">
      <li class="wc-list-pagination-li page-item">
        <a class="wc-list-pagination-a page-link asf-dwr"></a>
      </li>
    </ul>
    <small class="wc-list-pagination-small text-secondary"></small>
  </nav>
`;

export class WCListPagination extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    // let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListPagination = clone.content.querySelector('.wc-list-pagination').cloneNode();
    let wcListPaginationUl = clone.content.querySelector('.wc-list-pagination-ul').cloneNode();
    let wcListPaginationSmall = clone.content.querySelector('.wc-list-pagination-small').cloneNode();
    let dataPaginacao = $$.tool.dataJSON(this.getAttribute('data-paginacao'));
    let hideLower = false;
    let hideUpper = false;
    for (let pagina = 1; pagina <= dataPaginacao.paginas; pagina += 1) {
      let wcListPaginationLi = clone.content.querySelector('.wc-list-pagination-li').cloneNode(false);
      let wcListPaginationA = clone.content.querySelector('.wc-list-pagination-a').cloneNode(false);
      wcListPaginationA.setAttribute('class', [this.getAttribute('class'), wcListPaginationA.getAttribute('class')].join(' '));
      if (
        pagina === 1 ||
        pagina === dataPaginacao.paginas ||
        (
          pagina >= (dataPaginacao.pagina - 5) &&
          pagina <= (dataPaginacao.pagina + 5)
        )
      ) {
        wcListPaginationA.setAttribute('href', '#!');
        if (pagina === Number(dataPaginacao.pagina)) {
          wcListPaginationA.classList.add('active');
        }
        wcListPaginationA.dataset.pagina = pagina;
        wcListPaginationA.append(document.createTextNode(pagina));
        wcListPaginationLi.append(wcListPaginationA);
      } else if (pagina < (dataPaginacao.pagina - 5) && !hideLower) {
        hideLower = true;
        wcListPaginationA.append(document.createTextNode('...'));
        wcListPaginationLi.append(wcListPaginationA);
      } else if (pagina > (dataPaginacao.pagina + 5) && !hideUpper) {
        hideUpper = true;
        wcListPaginationA.append(document.createTextNode('...'));
        wcListPaginationLi.append(wcListPaginationA);
      }
      wcListPaginationUl.append(wcListPaginationLi);
    }
    wcListPaginationSmall.append(document.createTextNode('Total de registros encontrados: ' + dataPaginacao.total + ' - ' + 'Resultados por página: ' + dataPaginacao.limite));
    wcListPagination.append(wcListPaginationUl, wcListPaginationSmall);
    this.replaceWith(wcListPagination);
  }

}